import { useMutation } from "@tanstack/react-query";

import { CreateStatsSessionRequestDto } from "@/shared/api";
import { useApi } from "@/shared/api/use-api";

export const useCreateSession = () => {
  const { statsControllerApi } = useApi();

  return useMutation({
    mutationFn: (data: CreateStatsSessionRequestDto) =>
      statsControllerApi.createStatsSession(data),
  });
};
